import React, { useEffect, useState } from "react";
import styles from "./ChangePassword.module.css";
import Modal from "../../Atoms/Modal/Modal";
import ModalChildrenContainer from "../../Atoms/Modal/ModalChildrenContainer";
import Buttons from "../../Atoms/Buttons/Buttons";
import { toast } from "react-toastify";
import TextInput from "../../Atoms/Inputs/TextInput";
import emailicon from "../../../assets/Imagess/emailinputicon.svg";
import ProfilePsswordIcon from "../../../assets/Imagess/GreyPasswordIcon.svg";

const UserModal = ({
  handleOnClose,
  ChangePassword,
  setNewPassword,
  setOldPassword,
}) => {
  //------------------------------------------------------
  const [error, setError] = useState(false);
  const [current, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [repeatedPassword, setRepeatedPassword] = useState("");

  const Validation = () => {
    if (password !== repeatedPassword) {
      toast.error("Password not match");
    } else if (!current || !password || !repeatedPassword) {
      toast.error("Enter the required fields");
    } else if (password.length < 5 || repeatedPassword.length < 5) {
      toast.error("At least 8 digits password");
    } else if (current && password === repeatedPassword) {
      ChangePassword();
    }
  };
  //------------------------------------------------------

  return (
    <Modal
      onClose={handleOnClose}
      title={'Change Password'}
      width="44rem"
      scrollY="auto"
      closeWhite={false}
    >
      <ModalChildrenContainer>
        <div className={`${styles['modalRow']}   `}>
          <div className={styles['w-100']}>
            <TextInput
              icon={ProfilePsswordIcon}
              width="100%"
              label="Current Password"
              type={'password'}
              value={current}
              placeholder={'Enter Current Password'}
              onChange={(e, value) => {
                setCurrent(value);
                setOldPassword(value);
              }}
            />
            <TextInput
              icon={ProfilePsswordIcon}
              width="100%"
              label="New Password"
              type={'password'}
              value={password}
              placeholder={'Enter New Password'}
              onChange={(e, value) => {
                setPassword(value);
                setNewPassword(value);
              }}
            />
            <TextInput
              icon={ProfilePsswordIcon}
              width="100%"
              label="Repeat New Password"
              type={'password'}
              value={repeatedPassword}
              placeholder={'Repeat New Password'}
              onChange={(e, value) => {
                setRepeatedPassword(value);
              }}
            />
          </div>
        </div>

        <div className={`${styles['footer-container']}`}>
          {' '}
          {/* <Buttons
            text="Cancel"
            handleOnClick={() => {
              handleOnClose();
            }}
            rounded
            color={"#A6A6A6"}
            width={"49%"}
            style={{ fontFamily: "BukraBold", padding: "15px" }}
          /> */}
          {'   '}
          <Buttons
            text="حفظ كلمة المرور"
            handleOnClick={() => {
              Validation();
            }}
            rounded
            color={'#0DA06E'}
            width={'100%'}
            style={{ fontFamily: 'BukraBold', padding: '15px' }}
          />
        </div>
      </ModalChildrenContainer>
    </Modal>
  );
};

export default UserModal;
